import { RADIUS_SLIDER_HALF_POINT_KMS } from '@/constants/location'
import { type LocationArea } from '@/generated'
import { type GlobalLocation } from '@/lib/apollo/locationCache'

/**
 * Gets the location area from either a new area if all the values are defined
 * Or the one that has been selected previously
 * If none are defined, it returns undefined
 * */
export const getLocationArea = (
  currLocation?: GlobalLocation | null,
  newArea?: GlobalLocation | null
): LocationArea | undefined => {
  /** Should only return location area if all values are available */
  if (newArea?.latitude && newArea.longitude && newArea.streetAddress) {
    return {
      latitude: newArea.latitude,
      longitude: newArea.longitude,
      radius: newArea.radius || RADIUS_SLIDER_HALF_POINT_KMS,
      address: newArea.streetAddress,
    }
  }

  if (currLocation?.latitude && currLocation.longitude && currLocation.streetAddress) {
    return {
      latitude: currLocation.latitude,
      longitude: currLocation.longitude,
      radius: currLocation.radius || RADIUS_SLIDER_HALF_POINT_KMS,
      address: currLocation.streetAddress,
    }
  }

  return undefined
}
